export default __webpack_public_path__ + "static/media/vikas.0562130b.jpeg";